import { render, staticRenderFns } from "./employee-import.vue?vue&type=template&id=2b84a2c5&scoped=true"
import script from "./employee-import.vue?vue&type=script&lang=js"
export * from "./employee-import.vue?vue&type=script&lang=js"
import style0 from "./employee-import.vue?vue&type=style&index=0&id=2b84a2c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84a2c5",
  null
  
)

export default component.exports